import * as actionTypes from './actionTypes';

export const createPostRequest = () => ({ type: actionTypes.POST_CREATE_REQUEST });
export const createPostError = (payload) => ({ type: actionTypes.POST_CREATE_ERROR, payload });
export const createPostStore = (payload) => ({ type: actionTypes.POST_CREATE_SUCCESS, payload });

export const uploadRequest = (payload) => ({ type: actionTypes.UPLOAD_REQUEST, payload });
export const uploadError = (payload) => ({ type: actionTypes.UPLOAD_ERROR, payload });
export const uploadStore = (payload) => ({ type: actionTypes.UPLOAD_SUCCESS, payload });

export const deleteMediaRequest = (payload) => ({ type: actionTypes.DELETE_MEDIA_REQUEST, payload });

export const socialPagesRequest = (payload) => ({ type: actionTypes.SOCIAL_PAGES_GET_LIST_REQUEST, payload });
export const socialPagesError = (payload) => ({ type: actionTypes.SOCIAL_PAGES_GET_LIST_ERROR, payload });
export const socialPagesStore = (payload) => ({ type: actionTypes.SOCIAL_PAGES_GET_LIST_STORE, payload });

export const resetPostState = () => ({ type: actionTypes.POST_RESET_STATE });
